import { withInstall } from '@tw-element/utils'

import Alert from './src/alert.vue'

export const TwAlert = withInstall(Alert)
export default TwAlert

export * from './src/alert'
